function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* @indexer:no-export */
import React from 'react';
import './SortDirection.css';
import Button from '../../Buttons/Button/Button';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import cs from 'classnames';
import Ascending from '../../Icons/Ascending/Ascending';
import Descending from '../../Icons/Descending/Descending';
import { default as withInputContainer } from '../../Inputs/withInputContainer/withInputContainer';
import whitelistProps from '../../utils/whitelistProps';
import noop from '../../utils/noop';
var whitelist = whitelistProps();
export function SortDirection(_ref) {
  var auto = _ref.auto,
    label = _ref.label,
    labelIcons = _ref.labelIcons,
    labelHidden = _ref.labelHidden,
    descriptionId = _ref.descriptionId,
    errorId = _ref.errorId,
    errorMsg = _ref.errorMsg,
    width = _ref.width,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    id = _ref.id,
    value = _ref.value,
    name = _ref.name,
    style = _ref.style,
    required = _ref.required,
    disabled = _ref.disabled,
    readonly = _ref.readonly,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    attrs = _objectWithoutProperties(_ref, ["auto", "label", "labelIcons", "labelHidden", "descriptionId", "errorId", "errorMsg", "width", "size", "id", "value", "name", "style", "required", "disabled", "readonly", "onBlur", "onChange", "onFocus"]);
  var styl = width ? Object.assign({}, style, {
    width: width
  }) : style;
  return /*#__PURE__*/React.createElement("div", {
    className: cs("_dm-input _dm-input--".concat(size, " _dm-sort-direction-input"), _defineProperty({}, auto, auto)),
    style: styl
  }, /*#__PURE__*/React.createElement("input", Object.assign({
    "aria-disabled": disabled,
    "aria-readonly": readonly,
    "aria-required": !!required,
    className: "auto-sort-direction-input",
    disabled: disabled,
    id: id,
    name: name,
    readOnly: readonly,
    required: required,
    type: "hidden",
    value: value
  }, whitelist(attrs))), /*#__PURE__*/React.createElement(Button, {
    "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
    "aria-errormessage": errorId,
    "aria-invalid": !!errorMsg,
    "aria-pressed": value === 'ascending',
    className: "_dm-sort-direction-input__toggle",
    onBlur: onBlur,
    onClick: function onClick() {
      return readonly ? noop : onChange(value === 'ascending' ? undefined : 'ascending');
    },
    onFocus: onFocus,
    type: "button"
  }, /*#__PURE__*/React.createElement(Ascending, {
    width: 13,
    height: 13,
    style: {
      height: 'auto',
      width: 'auto',
      margin: 0
    }
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    i18nKey: "Ascending"
  })), /*#__PURE__*/React.createElement(Button, {
    "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
    "aria-errormessage": errorId,
    "aria-invalid": !!errorMsg,
    "aria-pressed": value === 'descending',
    className: "_dm-sort-direction-input__toggle",
    onBlur: onBlur,
    onClick: function onClick() {
      return readonly ? noop : onChange(value === 'descending' ? undefined : 'descending');
    },
    onFocus: onFocus,
    type: "button"
  }, /*#__PURE__*/React.createElement(Descending, {
    width: 13,
    height: 13,
    style: {
      height: 'auto',
      width: 'auto',
      margin: 0
    }
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    i18nKey: "Descending"
  })));
}
export default withInputContainer()(SortDirection);